export default __webpack_public_path__ + "static/media/document.68d09632.svg";